import { RelatedDataEntity } from '@mark43/cad-api';
import { createCell, SimpleTable } from '../../../common/components/simple-table';
import { generatePriorCadEventsRowData } from './helpers';
import { FR_EVENT_DETAILS_TABS } from '../../../fr-event-details-page/constants';
import { useOpenEvent } from '../../../common/hooks/use-open-event';

const tableStyles = [
    { whiteSpace: 'nowrap' as const },
    { whiteSpace: 'nowrap' as const },
    { whiteSpace: 'nowrap' as const },
];

export function PriorCadEventsTable({ cadEvents = [] }: { cadEvents?: RelatedDataEntity[] }) {
    const openEventHandler = useOpenEvent();

    const cadEventsRows = [
        [
            createCell({ content: 'Event #' }),
            createCell({ content: 'CFS' }),
            createCell({ content: 'Dispo' }),
        ],
        ...generatePriorCadEventsRowData(cadEvents, (eventId) =>
            openEventHandler({ eventId, frEventDetailsTabName: FR_EVENT_DETAILS_TABS.NARRATIVE })
        ),
    ];

    return (
        <SimpleTable
            columnStyles={tableStyles}
            rows={cadEventsRows}
            emptyState="No CAD Events Found"
            hasBorders={false}
        />
    );
}
